/* GB Threads: truthful milestone progress + editable, DISPLAY-ONLY personalization fee.
   Art files are prepared before cart; 100% signals design creation, not Shopify cart submission.
*/
(function(){'use strict';
if(window.GBStudioProgress)return;
const KEY='gbcs-studio-pending-v1',MAX_AGE=20*60*1000;
let dialog=null,percent=0,status='idle',creationStarted=0,creating=false,createTarget=0;
const format=cents=>'Rs. '+(Number(cents)/100).toLocaleString('en-PK',{minimumFractionDigits:0,maximumFractionDigits:2});
function find(name){return dialog?.querySelector('[data-gbcs-p-'+name+']')}
function ui(){
 if(dialog&&dialog.isConnected)return dialog;
 dialog=document.createElement('div');dialog.className='gbcs-progress';dialog.setAttribute('popover','manual');dialog.setAttribute('role','status');dialog.setAttribute('aria-label','Personalized order preparation');
 dialog.innerHTML='<div class="gbcs-progress__card"><div class="gbcs-progress__emblem" aria-hidden="true">GB</div><div class="gbcs-progress__eyebrow">GB THREADS / PERSONALIZED</div><h2 class="gbcs-progress__title" data-gbcs-p-title>Preparing your design</h2><p class="gbcs-progress__message" data-gbcs-p-message aria-live="polite">Getting your personalized garment ready…</p><div class="gbcs-progress__meter" role="progressbar" aria-label="Custom logo preparation" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-gbcs-p-meter><div class="gbcs-progress__fill" data-gbcs-p-fill></div></div><div class="gbcs-progress__readout"><span data-gbcs-p-caption>Preparing artwork</span><b data-gbcs-p-percent>0%</b></div><div class="gbcs-progress__divider"></div><div class="gbcs-progress__steps"><span data-gbcs-p-step="0">Artwork</span><span data-gbcs-p-step="1">Garment preview</span><span data-gbcs-p-step="2">Maker sheet</span><span data-gbcs-p-step="3">Final design</span></div><button type="button" class="gbcs-progress__button" data-gbcs-p-close hidden>Close</button></div>';
 document.body.appendChild(dialog);
 find('close').addEventListener('click',hide);
 return dialog;
}
function show(){
 const d=ui();
 d.style.removeProperty('display');
 d.removeAttribute('data-gbcs-progress-fallback');
 try{if(typeof d.showPopover==='function'&&!d.matches(':popover-open'))d.showPopover();}
 catch(err){d.setAttribute('data-gbcs-progress-fallback','');}
 if(!d.matches(':popover-open'))d.setAttribute('data-gbcs-progress-fallback','');
}
function hide(){
 if(!dialog)return;
 if(dialog.matches(':popover-open')){try{dialog.hidePopover()}catch(_){}}
 dialog.removeAttribute('data-gbcs-progress-fallback');
 dialog.style.display='none';status='idle';creating=false;
}
function paint(n,message,caption){
 show();dialog.style.removeProperty('display');
 percent=Math.max(percent,Math.min(100,Math.round(n)));
 find('percent').textContent=percent+'%';
 find('fill').style.setProperty('width',percent+'%','important');
 find('meter').setAttribute('aria-valuenow',String(percent));
 if(message)find('message').textContent=message;
 if(caption)find('caption').textContent=caption;
 const count=percent>=100?4:percent<30?0:percent<65?1:percent<89?2:3;
 dialog.querySelectorAll('[data-gbcs-p-step]').forEach(el=>el.classList.toggle('is-done',Number(el.dataset.gbcsPStep)<count));
}
function start(){
 status='running';percent=0;show();dialog.style.removeProperty('display');dialog.dataset.status='loading';
 find('title').textContent='Making it yours.';
 find('close').hidden=true;
 paint(0,'Checking your chosen artwork and print measurements…','Validating design');
}
function stage(n,message,caption){
 if(status!=='running')return;
 if(creating){
  createTarget=Math.max(createTarget,Math.min(97,n));
  if(message)find('message').textContent=message;
  if(caption)find('caption').textContent=caption;
  return;
 }
 paint(Math.min(n,97),message,caption);
}
function fail(message){
 status='error';creating=false;show();dialog.style.removeProperty('display');dialog.dataset.status='error';
 find('title').textContent='Needs your attention';
 find('message').textContent=message||'Could not prepare this artwork. Please review the design and retry.';
 find('caption').textContent='Nothing has been confirmed in Shopify cart';
 find('close').hidden=false;
}
function handoff(requestId){
 if(status!=='running')return;
 try{sessionStorage.setItem(KEY,JSON.stringify({id:requestId,at:Date.now()}));}catch(_){}
 paint(97,'Uploading your files to Shopify. Please keep this page open…','Waiting for cart confirmation');
}
async function verifyCart(){
 let saved;try{saved=JSON.parse(sessionStorage.getItem(KEY)||'null')}catch(_){}
 if(!saved||!saved.id)return;
 try{sessionStorage.removeItem(KEY)}catch(_){}
 if(!saved.at||Date.now()-saved.at>MAX_AGE)return;
 try{
  const root=window.Shopify?.routes?.root||'/';
  const url=root.replace(/\/?$/,'/')+'cart.js';
  const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}});
  if(!response.ok)throw Error('Could not verify Shopify cart');
  const cart=await response.json();
  const found=(cart.items||[]).some(item=>item.properties?.['_GB Studio Request ID']===saved.id);
  if(!found){fail('We could not confirm this design was added. Please check your shopping bag before trying again.');return;}
  // Customer is already on the cart page: avoid a second fullscreen progress modal.
  return;
 }catch(_){fail('Could not verify the latest personalized item in Shopify cart. Please check your bag before retrying.');}
}
function feeCents(root){
  const side=root.querySelector('[data-gbcs-target]:checked')?.value||'front';
  const uploaded=!!root.querySelector('[data-gbcs-source][value="upload"]')?.checked;
  const key=uploaded?'gbcsFeeUpload'+side.charAt(0).toUpperCase()+side.slice(1):'gbcsFee'+side.charAt(0).toUpperCase()+side.slice(1);
  return Math.max(0,Math.round(Number(root.dataset[key]||0)*100));
}
function refreshPrice(root){
 const panel=root.querySelector('[data-gbcs-pricing]');if(!panel)return;
 const custom=!!root.querySelector('[data-gbcs-mode][value="custom"]:checked');
 panel.hidden=!custom;if(!custom)return;
 let base=Number(root.dataset.gbcsBasePriceCents||0);
 try{
  const list=JSON.parse(root.dataset.gbcsVariantPrices||'[]');
  const id=String(root.closest('form')?.querySelector('[name="id"]')?.value||'');
  const found=list.find(x=>String(x.id)===id);
  if(found)base=Number(found.price)||base;
 }catch(_){}
 const side=root.querySelector('[data-gbcs-target]:checked')?.value||'front';
 const fee=feeCents(root);
 panel.querySelector('[data-gbcs-base-price]').textContent=format(base);
 panel.querySelector('[data-gbcs-price-side]').textContent='('+({front:'Front',back:'Back',both:'Front + back'}[side]||'Front')+')';
 panel.querySelector('[data-gbcs-logo-fee]').textContent=fee>0?format(fee)+' · estimated':'Awaiting price approval';
 panel.querySelector('[data-gbcs-total-price]').textContent=fee>0?format(base+fee)+' estimated':'To be confirmed';
 panel.querySelector('[data-gbcs-pricing-disclaimer]').textContent='Fee rule: '+(root.querySelector('[data-gbcs-source][value="upload"]')?.checked?'Uploaded logo':'Text / initials')+' + '+({front:'Front',back:'Back',both:'Front + back'}[side]||'Front')+'. Size and print method pricing are not configured. Fees are estimates only; Shopify currently charges the garment variant price.';
}
function setupPricing(){
 document.querySelectorAll('[data-gbcs]').forEach(root=>{
  if(root.dataset.gbcsPricingReady)return;root.dataset.gbcsPricingReady='yes';
  const update=()=>refreshPrice(root);
  root.addEventListener('change',update);
  root.closest('form')?.addEventListener('change',update);
  root.addEventListener('click',e=>{if(e.target.closest('[data-gbcs-target],.gbcs__mode'))queueMicrotask(update)});
  update();
 });
}

/* Design creation is separate from checkout. Progress follows real preparation milestones. */
function createStart(){
 creationStarted=performance.now();
 start();creating=true;createTarget=0;
 // Show continuous *visual* activity over ~3.5s while real artwork tasks run.
 // Percentage is a UI preparation indicator, NOT a completed-file claim;
 // 100% remains gated by createDone after all files exist.
 const tick=()=>{
  if(status!=='running'||!creating)return;
  const elapsed=performance.now()-creationStarted;
  // Never automatically reach 100: show gradual motion even during long canvas work.
  const target=Math.min(94,Math.floor((elapsed/3500)*94));
  if(target>percent)paint(target);
  if(elapsed>4300&&percent>=92&&find('caption')?.textContent!=='Finishing final design files'){
    find('caption').textContent='Finishing final design files';
  }
  requestAnimationFrame(tick);
 };
 requestAnimationFrame(tick);
 find('title').textContent='Creating your design';
 find('message').textContent='Preparing artwork and your garment previews…';
}
function wait(ms){return new Promise(resolve=>setTimeout(resolve,ms))}
async function createDone(){
 if(status!=='running')throw Error('Design creation was interrupted');
 const elapsed=performance.now()-creationStarted;
 // Keep progress visibly moving for approximately 3.5 seconds; artwork must already exist.
 if(elapsed<3500)await wait(3500-elapsed);
 if(status!=='running')throw Error('Design creation was interrupted');
 creating=false;
 paint(100,'Your design is ready. Opening the final preview…','Preview created');
 status='success';
 dialog.dataset.status='success';
 find('title').textContent='Design created!';
 await wait(700);
 hide();
}
function handoffSmall(requestId){
 try{sessionStorage.setItem(KEY,JSON.stringify({id:requestId,at:Date.now()}))}catch(_){}
 hide(); // Small inline loader is shown on the final design card instead.
}
window.GBStudioProgress=Object.freeze({start,stage,fail,handoff,hide,refreshPrice,feeCents,createStart,createDone,handoffSmall});
const boot=()=>{setupPricing();verifyCart()};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',setupPricing);
})();